import { Skeleton } from '@/components/atoms/Skeleton';
import GiftCardValoresGridFallback from '@/components/molecules/GiftCardValoresGrid/fallback';
import PaginaVendaDesktopFallback from '@/components/templates/PaginaVendaDesktopTemplate/fallback';
import { theme } from '@/styles/theme';

export default function ProdutoPaginaDesktopFallback() {
  return (
    <PaginaVendaDesktopFallback
      $fallbackConteudoCheckout={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[5],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[4],
            }}
          >
            <Skeleton style={{ height: 25, width: 150 }} />
            <GiftCardValoresGridFallback />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Skeleton style={{ height: 25, width: 100 }} />
            <Skeleton style={{ height: 34, width: 116 }} />
          </div>
        </div>
      }
      $fallbackConteudoDescritivo={
        <div>
          <Skeleton style={{ height: 200 }} />
        </div>
      }
    />
  );
}
